import { DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs } from 'cerialize';

export class UserSecurityDetails {
  @autoserialize
  id: number;

  @autoserialize
  personId: number;

  @autoserialize
  username: string;

  @autoserializeAs(Date)
  expires: Date;

  @autoserialize
  authorities: Array<string>;

  /**** Serialization ****/

  static OnSerialized(instance: UserSecurityDetails, json: any): void {
    if (!isNullOrUndefined(instance.expires)) {
      json.expires = DateUtil.serializeDate(instance.expires);
    }
    if (!isNullOrUndefined(instance.authorities)) {
      json.authorities = instance.authorities.map(authority => ({ authority: authority }));
    }
  }

  static OnDeserialized(instance: UserSecurityDetails, json: any): void {
    if (!isNullOrUndefined(json['expires'])) {
      instance.expires = DateUtil.deserializeDate(json['expires']);
    }
    if (!isNullOrUndefined(json['authorities']) && Array.isArray(json['authorities'])) {
      instance.authorities = json['authorities'].map(authority => authority['authority']);
    }
  }
}
